export default __webpack_public_path__ + "static/media/starbuck-star.b5866b3e.webp";